import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { EditPhotoPolygons } from './EditPhotoPolygons.tsx'
import { PhotoOwnerCaption } from '@/entities/Photos'
import { useTranslation } from 'react-i18next'

type EditPhotoPolygonsModalProps = {
  dialogProps: AlertDialogProps
  selectedPhotoId: number
  queryKeyForObjectUpdate: string
  obj_id: number
  owner: PhotoOwnerCaption
  buildings?: { id: number; name: string }[]
  onCloseModal: () => void
}

export const EditPhotoPolygonsModal: FC<EditPhotoPolygonsModalProps> = props => {
  const {
    dialogProps,
    selectedPhotoId,
    queryKeyForObjectUpdate,
    obj_id,
    owner,
    buildings = [],
    onCloseModal,
  } = props
  const { t } = useTranslation(['photo'])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh] min-w-[80vw]'}>
        <DialogHeader>
          <DialogTitle>{t('photo:edit_polygons')}</DialogTitle>
          <EditPhotoPolygons
            selectedPhotoId={selectedPhotoId}
            queryKeyForObjectUpdate={queryKeyForObjectUpdate}
            obj_id={obj_id}
            owner={owner}
            buildings={buildings}
            onCloseModal={onCloseModal}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
